export default {
  setLoading({ commit }, isLoading) {
    return commit('SET_LOADING', isLoading);
  },
  setButtonLoading({ commit }, isButtonLoading) {
    return commit('SET_BUTTON_LOADING', isButtonLoading);
  },
  openErrorModal({ commit }, isErrorModalOpened) {
    return commit('OPEN_ERROR_MODAL', isErrorModalOpened);
  },
  openBiometricModal({ commit }, isBiometricModalOpened) {
    return commit('OPEN_BIOMETRIC_MODAL', isBiometricModalOpened);
  },
  openTermsModal({ commit }, isTermsModalOpened) {
    return commit('OPEN_TERMS_MODAL', isTermsModalOpened);
  },
  setErrors({ commit }, errors) {
    return commit('SET_ERRORS', errors);
  },
  setErrorFields({ commit }, errorFields) {
    return commit('SET_ERROR_FIELDS', errorFields);
  },
  resetErrorFields({ commit }) {
    return commit('RESET_ERROR_FIELDS');
  },
  setModalBackToRoute({ commit }, modalBackToRoute) {
    commit('SET_MODAL_BACK_TO_ROUTE', modalBackToRoute);
  },
  setHasNotification({ commit }, payload) {
    commit('SET_HAS_NOTIFICATION', payload.hasNotification);
  },
  setModalTitle({ commit }, modalTitle) {
    commit('SET_MODAL_TITLE', modalTitle);
  },
  setBackRouteName({ commit }, backRouteName) {
    commit('SET_BACK_ROUTE_NAME', backRouteName);
  },
  setQrRouteData({ commit }, qrRouteData) {
    commit('SET_QR_ROUTE_DATA', qrRouteData);
  },
  resetQrRouteData({ commit }) {
    commit('SET_QR_ROUTE_DATA', {});
  },
  notClickOutside({ commit }, notClickOutside) {
    return commit('CLICK_OUT_SIDE', notClickOutside);
  },
  setPayCameraOpen({ commit }, isPayCameraOpened) {
    return commit('SET_PAY_CAMERA_OPEN', isPayCameraOpened);
  },
};
